export function XaxisTickFormat(value){
   if(value){
      let rounded = value.toFixed(1)
      return rounded
   }
   return value
}
export default XaxisTickFormat;